import { render, staticRenderFns } from "./EditDrugParasite.vue?vue&type=template&id=7652d950"
import script from "./EditDrugParasite.vue?vue&type=script&lang=js"
export * from "./EditDrugParasite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports